// extracted by mini-css-extract-plugin
module.exports = {"label":"label__G7Zqx","input":"input__3WfQ0","warningBox":"warningBox__2oXpY","warning":"warning__1nJiP"};